import React, { useState } from 'react'
import useForm from "../../services/useForm";
import validate from '../../services/validations/registerFormValidationRules';

import { Header } from '../../components/Header'
import { Footer } from '../../components/Footer'

export const Register = () => {
    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(register, validate);

    const [success, setSuccess] = useState(false);
    const [roles, setRoles] = useState(getRoles());
    const [role, setRole] = useState('customer');
    const [hasErrors, setHasErrors] = useState(false);
    const [hasDuplicatedUserException, setHasDuplicatedUserException] = useState(false);
    const [errorMessages, setErrorMessages] = useState('');

    function getRoles() {
        return [
            { label: "Vendedor", value: "supplier" },
            { label: "Usuario", value: "customer" }
        ];
    }

    function goLogin() {
        window.location.href = '/signin';
    }

    function showDefaultErrorMessage() {
        setErrorMessages('Ha ocurrido un error inesperado, por favor vuelva a intentarlo.')
        setHasErrors(true);
    }

    function register() {
        setSuccess(false)
        setHasErrors(false)
        setHasDuplicatedUserException(false);
        setErrorMessages('')

        fetch(process.env.REACT_APP_API_URL + "/auth/register", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(
                {
                    name: values.name,
                    surname: values.surname,
                    role: role,
                    email: values.email,
                    password: values.password
                })
        })
            .then((response) => {
                debugger;
                if (response.ok) {
                    setSuccess(true);
                }
                else {
                    if (response.status === 500) {
                        showDefaultErrorMessage();
                    }
                    else {
                        response.json().then(data => {
                            data.errors.forEach((error) => {
                                if (error === 'DuplicateUserNameException') {
                                    setHasDuplicatedUserException(true);
                                }
                                else {
                                    showDefaultErrorMessage();
                                }
                            })
                        });
                    }
                }
            })
            .catch(function (error) {
                showDefaultErrorMessage();
            });
    }
    return (
        <>
            <Header />
            {!success &&
                <div id="sign-in-dialog" className="zoom-anim-dialog">
                    <div>
                        <h2>Regístrate en gamarreando</h2>
                    </div>
                    <br />
                    {hasErrors &&
                        <div className="notification error closeable">
                            <p>{errorMessages}</p>
                        </div>
                    }
                    {hasDuplicatedUserException &&
                        <div className="notification warning closeable">
                            <p>El usuario ingresado ya está registrado. Pulse en iniciar sesión</p>
                            <br />
                            <button className="button" onClick={goLogin}>Iniciar sesión</button>
                        </div>
                    }
                    <div className="sign-in-form style-1">
                        <form onSubmit={handleSubmit} className="register">
                            <p className="form-row form-row-wide">
                                <label for="apellidos">Registrarme como: </label>
                                <select value={role}
                                    onChange={e => setRole(e.currentTarget.value)}>
                                    {roles.map(item => (
                                        <option key={item.value} value={item.value}>{item.label}</option>
                                    ))}
                                </select>
                            </p>
                            <p className="form-row form-row-wide">
                                <label for="name">Nombres:</label>
                                <input type="text" className="input-text" name="name" onChange={handleChange} value={values.name || ''} />
                                {errors.name && (
                                    <p className="help is-danger">{errors.name}</p>
                                )}
                            </p>
                            <p className="form-row form-row-wide">
                                <label for="surname">Apellidos: </label>
                                <input type="text" className="input-text" name="surname" onChange={handleChange} value={values.surname || ''} />
                                {errors.surname && (
                                    <p className="help is-danger">{errors.surname}</p>
                                )}
                            </p>
                            <p className="form-row form-row-wide">
                                <label for="email2">Email:
                                <i className="im im-icon-Mail"></i>
                                    <input type="email" className="input-text" name="email" onChange={handleChange} value={values.email || ''} />
                                </label>
                                {errors.email && (
                                    <p className="help is-danger">{errors.email}</p>
                                )}
                            </p>
                            <p className="form-row form-row-wide">
                                <label for="password1">Contraseña:
                                <i className="im im-icon-Lock-2"></i>
                                    <input type="password" className="input-text" name="password" onChange={handleChange} value={values.password || ''} />
                                </label>
                                {errors.password && (
                                    <p className="help is-danger">{errors.password}</p>
                                )}
                                <span className="spanColor">
                                    Al hacer clic en <strong>"Crear tu cuenta"</strong>, declaro que acepto los <a className="lost_password" target="_blank" href="/terms" >Términos de Uso</a> y que he leído la <a className="lost_password" target="_blank" href="/privacyPolicy" >Política de Privacidad.</a>
                                </span>
                            </p>
                            <input type="submit" className="button border fw margin-top-10" name="register" value="Crear tu cuenta" />
                        </form>
                    </div>
                </div>
            }
            {success &&
                <div id="sign-in-dialog" className="zoom-anim-dialog">
                    <div className="row">
                        <div className="col-md-12">

                            <h3>Tu usuario ha sido creado correctamente</h3>

                            <div className="notification success closeable">
                                <h4>Te hemos enviado un email para puedas activar tu cuenta.
                                Si no lo encuentras en tu bandeja de entrada, revisa en la carpeta de spam.
                                    <br /> <br /> Si al cabo de unos minutos no recibes el email, escribenos a <strong>{process.env.REACT_APP_SUPPORT_EMAIL}</strong></h4>
                            </div>

                        </div>
                        <div className="col-md-12">
                            <button className="button" onClick={goLogin}>Iniciar Sesión</button>
                        </div>
                    </div>
                </div>
            }
            <Footer />
        </>
    )
}